import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Link } from '@express-labs/raven-ui';
import s from './LongDescriptionModal.scss';

function LongDescriptionModal({ longDescription, shortDescriptionCta, subheading }) {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleModalOpen = useCallback(() => {
    setModalOpen((prevState) => !prevState);
  }, []);

  return (
    <>
      <Link
        as="button"
        theme="dark"
        size="body"
        className={s.buttonLink}
        onClick={handleModalOpen}
      >
        {shortDescriptionCta}
      </Link>
      <Modal
        isOpen={isModalOpen}
        role="dialog"
        onModalClose={handleModalOpen}
        className={s.modalSection}
        closeIconClassName={s.closeIconClassName}
        hideCloseButton
        view="modal"
      >
        <h4 className={s.subHeading}>
          {subheading}
          <button
            type="button"
            aria-label="Close Modal"
            onClick={handleModalOpen}
            className={s.button}
          />
        </h4>
        <div className={s.contentBlock}>
          {longDescription
          && longDescription.map((item) => <p key={item} className="rvnP2">{item}</p>)}
        </div>
      </Modal>
    </>
  );
}

LongDescriptionModal.propTypes = {
  longDescription: PropTypes.arrayOf(PropTypes.string).isRequired,
  shortDescriptionCta: PropTypes.string.isRequired,
  subheading: PropTypes.string.isRequired,
};


export default LongDescriptionModal;
